export enum ScrollBehaviorTypes {
  SMOOTH = 'smooth',
  UNSET = 'unset',
}
export const setScrollBehaviour = (behavior: string): void => {
  document.getElementsByTagName('html')[0].style.scrollBehavior = behavior;
};
